<template>
  <table class="table table-sm table-borderless">
    <col width="30%" />
    <col width="70%" />
    <tr v-for="f in vars" :key="f.v">
      <td>{{ f.k }}</td>
      <td>{{ f.v }}</td>
    </tr>
  </table>
</template>

<script>
export default {
  props: {
    value: Object,
  },
  computed: {
    vars() {
      let vars = Object.keys(this.value).map((k) => {
        return { k: k, v: this.value[k] };
      });
      return vars;
    },
  },
};
</script>
